import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Tooltip } from 'reactstrap';

class Icon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle = () => {
    const { tooltipOpen } = this.state;
    this.setState({ tooltipOpen: !tooltipOpen })
  }

  render() {
    const {
      children,
      className,
      handleOnClick,
      id,
      isDisabled,
      link,
      placement,
      tooltipText,
      url,
    } = this.props;
    const { tooltipOpen } = this.state;
    return (
      <>
        &nbsp;&nbsp;
        {link ? (
          <Link
            className="table-link"
            id={id}
            to={url}
          >
            {children}
          </Link>
        ) : (
          <Button
            className={`table-link icon ${className}`}
            id={id}
            disabled={isDisabled}
            onClick={handleOnClick}
          >
            {children}
          </Button>
        )}
        {!isDisabled && (
          <Tooltip
            placement={placement}
            isOpen={tooltipOpen}
            target={id}
            toggle={this.toggle}
          >
            <div className="text-left">
              {tooltipText}
            </div>
          </Tooltip>
        )}
      </>
    )
  }
}

Icon.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  link: PropTypes.bool,
  placement: PropTypes.string,
  tooltipText: PropTypes.node.isRequired,
  url: PropTypes.string,
};

Icon.defaultProps = {
  className: '',
  handleOnClick: () => {},
  isDisabled: false,
  link: false,
  placement: undefined,
  url: '',
};

export default Icon;
